import { render } from "./TGUView.vue?vue&type=template&id=4673f2b4"
import script from "./TGUView.vue?vue&type=script&lang=js"
export * from "./TGUView.vue?vue&type=script&lang=js"

import exportComponent from "P:\\Web\\iacssconference\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__